'use client';
import { useSearchParams } from 'next/navigation';
import { useRef } from 'react';
import { determineInitialScreen } from 'src/lib/flows/utils';
import { useAppStore } from 'src/redux/hooks';
import { initializeForm } from 'src/redux/reducers/form';
import { initializeInputs } from 'src/redux/reducers/inputs';
import { setQueryParams } from 'src/redux/reducers/query-params';
import { getUserData } from 'src/redux/selectors';
import { getQueryParams } from 'src/utils/query-string';
import { parseQueryParams } from 'src/utils/query-string';

const InstantiateClientSideState = () => {
  const initialized = useRef<boolean>();
  const store = useAppStore();
  const searchParams = useSearchParams();
  if (!initialized.current) {
    const state = store.getState();
    const userData = getUserData(state);
    const queryParams = getQueryParams(parseQueryParams(searchParams) ?? {});
    const initialScreen = determineInitialScreen({
      isReturnUser: userData?.isReturnUser,
      queryParams: queryParams.inputs,
      experiments: {},
    });
    store.dispatch(setQueryParams(queryParams));
    store.dispatch(
      initializeForm({
        pageNumber: 0,
        currentStep: initialScreen,
        initialScreen,
        visitedScreens: [initialScreen],
      })
    );
    store.dispatch(initializeInputs(queryParams.inputs));
    initialized.current = true;
  }
  return null;
};

export default InstantiateClientSideState;
